import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { MyDatiBilancio } from '../../../models/interfaces/revisione.interface';

const HIDDEN_REQUIRED_DEFAULT = '0';

const setIfEmpty = <T, K extends keyof T>(obj: T, key: K, defaultValue: T[K]): void => {
    if (isNilOrEmpty(obj[key] as unknown as string)) {
        obj[key] = defaultValue;
    }
};

/**
 * Hidden required fields absent from every bilancio template and from older InfoPath XML versions:
 * left empty they would block validation with no way for the user to fill them (fedele al VBS → '0').
 */
export const setHiddenRequiredBilancioDefaults = (datiBilancio: MyDatiBilancio): void => {
    setIfEmpty(datiBilancio.my_StatoPatrimoniale__Attivo, 'my_StPaAtBIII2d11', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_StatoPatrimoniale__Attivo, 'my_StPaAtBIII2d12', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_StatoPatrimoniale__Passivo, 'my_StPaPsAV1', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_StatoPatrimoniale__Passivo, 'my_StPaPsAV2', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_StatoPatrimoniale__Passivo, 'my_StPaPsD6c1', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_StatoPatrimoniale__Passivo, 'my_StPaPsD6c2', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_ContoEconomico, 'my_CoEcF261', HIDDEN_REQUIRED_DEFAULT);
    setIfEmpty(datiBilancio.my_ContoEconomico, 'my_CoEcF262', HIDDEN_REQUIRED_DEFAULT);
};
